// --- Custom Donut Chart Component ---
import React from "react";
import StatsSection from "./StatsSection";

const DonutChart = () => {
  // Image ke sequence ke hisab se colors (Lightest to Darkest)
  const colors = [
    "#F7FCF5", // 12 baje se shuru (Top)
    "#E2F3D9",
    "#C1E5B4",
    "#8DCE85",
    "#59B567",
    "#05712F", // Darkest (Bottom Right section)
  ];

  const data = [17, 17, 17, 17, 17, 17]; // Sabhi segments barabar hain
  const total = data.reduce((a, b) => a + b, 0);

  const radius = 35;
  const strokeWidth = 18;
  const center = 50;
  const circumference = 2 * Math.PI * radius;

  let cumulativePercent = 0;

  return (
    <div className="relative w-full max-w-[80%] aspect-square flex items-center justify-center">
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full transform -rotate-90 drop-shadow-xl"
      >
        {data.map((value, index) => {
          const percent = value / total;
          const strokeDasharray = `${percent * circumference} ${circumference}`;
          const strokeDashoffset = -(cumulativePercent * circumference);

          // Label ki position nikalne ke liye math
          const angle = (cumulativePercent + percent / 2) * 360;
          const radians = (angle * Math.PI) / 180;
          const labelX = center + radius * Math.cos(radians);
          const labelY = center + radius * Math.sin(radians);

          cumulativePercent += percent;

          return (
            <g key={index}>
              <circle
                cx={center}
                cy={center}
                r={radius}
                fill="transparent"
                stroke={colors[index]}
                strokeWidth={strokeWidth}
                strokeDasharray={strokeDasharray}
                strokeDashoffset={strokeDashoffset}
                className="transition-all duration-700 ease-out"
              />
              {/* 17% Text inside segments */}
              <text
                x={labelX}
                y={labelY}
                fill={index === 5 ? "#ffffff" : "#1b0e02"} // Sirf darkest green par white text
                fontSize="4"
                fontWeight="bold"
                textAnchor="middle"
                alignmentBaseline="middle"
                transform={`rotate(90 ${labelX} ${labelY})`} // Text ko seedha rakhne ke liye
                className="font-parkinsans"
              >
                17%
              </text>
            </g>
          );
        })}
      </svg>

      {/* Optional: Center hole background fix if needed */}
      <div className="absolute w-[100%] h-[100%] rounded-full bg-transparent"></div>
    </div>
  );
};

const BiomassSection = () => {
  return (
    <section className="w-full">
      <div className="w-full ">
        {/* Network Capacity Stats Section (Keep your existing code here) */}
        <div className="flex flex-col items-center gap-[24px] md:gap-[36px] lg:gap-[48px]  px-4 md:px-[28px] lg:px-[56px] py-[50px] md:py-[75px] lg:py-[100px]">
          {/* ... (Your existing title and cards) ... */}
          <div className="flex flex-col items-center gap-[10px] md:gap-[15px] lg:gap-[20px] w-full max-w-[82%]">
            <h2 className="text-[30px] md:text-[60px] lg:text-[100px] font-parkinsans font-bold leading-[42px] md:leading-[84px] lg:leading-[140px] text-center text-[#343163]">
              Our Network Capacity
            </h2>
            <p className="text-[14px] md:text-[18px] lg:text-[24px] font-poppins font-light leading-[22px] md:leading-[28px] lg:leading-[38px] text-center text-[#1b0e02] w-full">
              It is very important to choose the right method of fertilizer
              application. Produced by Asia's largest bio-gas plant
              Govardhannathji Energies LLP. Which can be used as a complete
              alternative to natural cow-dung fertilizer. Public health so there
              is need of disposing waste in appropriate manner
            </p>
          </div>
          {/* Stats Cards */}

          <StatsSection />
        </div>

        {/* Sustainable Biomass Section */}
        <div className="flex flex-col lg:flex-row w-full overflow-hidden ">
          {/* Left Content */}
          <div className="w-full lg:w-1/2 bg-[#dcfbaf] flex flex-col gap-[19px] md:gap-[28px] lg:gap-[38px] justify-center items-center px-[23px] md:px-[34px] lg:px-[46px] py-[63px] md:py-[94px] ">
            <div className="flex flex-col items-start w-[88%]">
              <h3 className="text-[30px] md:text-[45px] lg:text-[60px] font-parkinsans font-bold leading-[42px] md:leading-[63px] lg:leading-[84px] text-left text-[#343163] w-full">
                Sustainable Biomass Selection
              </h3>
              <p className="text-[12px] md:text-[16px] lg:text-[20px] font-poppins font-light leading-[18px] md:leading-[24px] lg:leading-[30px] text-justify text-[#1c233a] w-[94%] mt-4">
                The quality and characteristics of biochar are significantly
                influenced by the type of biomass used in production. We select
                manufacturing partners who carefully choose sustainable biomass
                sources that would otherwise contribute to waste or pollution
                problems.
              </p>
            </div>
            <div className="flex flex-col gap-[12px] md:gap-[18px] lg:gap-[24px] w-full md:px-[52px] ">
              <div className="flex gap-[5px] md:gap-[7px] lg:gap-[10px] items-center w-full">
                <img
                  src="/assets/utpannProduction/selectionIcon.png"
                  alt="waste reduction icon"
                  className="w-[20px] md:w-[30px] lg:w-[40px] h-[20px] md:h-[30px] lg:h-[40px]"
                />

                <div className="flex flex-col items-start w-full">
                  <h4 className="text-[14px] md:text-[18px] lg:text-[24px] font-parkinsans font-bold leading-[20px] md:leading-[25px] lg:leading-[34px] text-left text-[#1b0e02]">
                    Waste Reduction
                  </h4>

                  <p className="text-[12px] md:text-[16px] lg:text-[20px] font-poppins font-light leading-[18px] md:leading-[24px] lg:leading-[30px] text-left text-[#1c233a]">
                    Converting agricultural waste into valuable resources
                  </p>
                </div>
              </div>

              <div className="flex gap-[5px] md:gap-[7px] lg:gap-[10px] items-center w-full">
                <img
                  src="/assets/utpannProduction/selectionIcon.png"
                  alt="fair sourcing icon"
                  className="w-[20px] md:w-[30px] lg:w-[40px] h-[20px] md:h-[30px] lg:h-[40px]"
                />

                <div className="flex flex-col items-start w-full">
                  <h4 className="text-[14px] md:text-[18px] lg:text-[24px] font-parkinsans font-bold leading-[20px] md:leading-[25px] lg:leading-[34px] text-left text-[#1b0e02]">
                    Fair Sourcing
                  </h4>

                  <p className="text-[12px] md:text-[16px] lg:text-[20px] font-poppins font-light leading-[18px] md:leading-[24px] lg:leading-[30px] text-left text-[#1c233a]">
                    Supporting local farmers through biomass purchase programs
                  </p>
                </div>
              </div>

              <div className="flex gap-[5px] md:gap-[7px] lg:gap-[10px] items-center w-full">
                <img
                  src="/assets/utpannProduction/selectionIcon.png"
                  alt="quality control icon"
                  className="w-[20px] md:w-[30px] lg:w-[40px] h-[20px] md:h-[30px] lg:h-[40px]"
                />

                <div className="flex flex-col items-start w-full">
                  <h4 className="text-[14px] md:text-[18px] lg:text-[24px] font-parkinsans font-bold leading-[20px] md:leading-[25px] lg:leading-[34px] text-left text-[#1b0e02]">
                    Quality Control
                  </h4>

                  <p className="text-[12px] md:text-[16px] lg:text-[20px] font-poppins font-light leading-[18px] md:leading-[24px] lg:leading-[30px] text-left text-[#1c233a]">
                    Ensuring rigorous testing of all incoming biomass materials
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Updated Statistics Chart */}
          <div className="w-full lg:w-1/2 bg-[linear-gradient(153deg,#195939_0%,#031312_100%)] flex flex-col gap-[20px] md:gap-[30px] lg:gap-[40px] justify-start items-center px-[28px] md:px-[42px] lg:px-[56px] py-[60px]">
            <h3 className="text-[24px] md:text-[36px] lg:text-[45px] font-parkinsans font-bold text-center text-white">
              Biomass Sourcing Statistics
            </h3>

            {/* Yaha par humne DonutChart component call kiya hai */}
            <DonutChart />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BiomassSection;
